import {InputContextValue} from 'components/common/CartItemBuilder/providers/InputProvider/types'
import {useCallback} from 'react'
import {Basic} from 'types'
import {hasGuests} from 'utils/guestCounterHelpers'
import {useUserInputStepManager} from './useUserInputStepManager'

export const useGuestsManager = (cartItemInputContextValue: InputContextValue) => {
  const getSavedData = useCallback(() => {
    return cartItemInputContextValue.input.unitCounters
  }, [cartItemInputContextValue])

  const setSavedData = useCallback(
    (unitCounters: Basic.UnitCounterMap) => {
      return cartItemInputContextValue.mutators.setUnitCounters({...unitCounters})
    },
    [cartItemInputContextValue]
  )

  const isDataTouched = useCallback((unitCounters: Basic.UnitCounterMap) => {
    return hasGuests(unitCounters)
  }, [])

  const isDataValid = useCallback((unitCounters: Basic.UnitCounterMap) => {
    return hasGuests(unitCounters)
  }, [])

  return useUserInputStepManager<Basic.UnitCounterMap>({
    getSavedData,
    setSavedData,
    isDataTouched,
    isDataValid,
    hint: 'Please enter the number of guests',
  })
}
